// Shared framer-motion presets (hoisted to avoid re-creating objects each render)
export const FADE_INITIAL = { opacity: 0, y: 20 };
export const FADE_IN_VIEW = { opacity: 1, y: 0 };
export const VIEWPORT_ONCE = { once: true, margin: "-60px" };

export const fadeUpVariants = {
  hidden: { opacity: 0, y: 24 },
  show: (i = 0) => ({
    opacity: 1,
    y: 0,
    transition: { duration: 0.5, delay: i * 0.08 },
  }),
};
